import { render, staticRenderFns } from "./PartyDescriptionCard.vue?vue&type=template&id=5d9af4dd"
import script from "./PartyDescriptionCard.vue?vue&type=script&lang=js"
export * from "./PartyDescriptionCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports